import React,{ useEffect, useState } from "react"
import './FormCreateAdmin.scss'
import userAdminService from "@/api/userAdmin.service"
import Box from '@mui/material/Box';
import institutesData from '@/api/JSON/InstitutesFresh.json'
import { generateRandomPassword, tokens } from "@/utilities"
import { Header } from "@/views";
import { Button, Checkbox, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Swal from "sweetalert2";
import facultyService from "@/api/faculty.service";
import { facultyProps } from "@/types";
import CloseIcon from '@mui/icons-material/Close';

const dataJSON = JSON.parse(JSON.stringify(institutesData))

interface InstituteOption {
  value: string;
  label: string;
}

export const FormCreateAdmin = () => {
  const [userRegister, setUserRegister]= useState({
    email: "",
    institution:"",
    phone:"",
    name:"",
    faculty: [] as string[],
    role:"",
    password: "",
    confirmPassword: "",
    autoAssign: true
  })

  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme()    
  const colors = tokens(theme.palette.mode);
  
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedOption, setSelectedOption] = useState<string>('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  
  const [faculties, setFaculties] = useState<facultyProps[] | null>([])
  const [openFacultySelect, setOpenFacultySelect] = useState(false);

  const filteredOptions = dataJSON.institutes
    .map((institute:any) => {
      const instituteCode = Object.keys(institute)[0];
      const instituteData = institute[instituteCode][1];
      if (instituteData && instituteData.name) {
        const label = `${instituteData.name} || ${instituteData.headquarters[0].city}`;
        return { value: instituteCode, label };
      }
      return null;
    })
    .filter((option: InstituteOption | null): option is InstituteOption => option !== null)
    .filter((option: InstituteOption) =>
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
   
    const handleSelectChange = (selectedValue: string) => {
      setSelectedOption(selectedValue);
      const selectedOption = filteredOptions.find((option: InstituteOption) => option.value === selectedValue);
      const selectedOptionLabel = selectedOption?.label || '';
      setSearchTerm(selectedOptionLabel);
      setUserRegister({
        ...userRegister,
        institution: selectedValue
      })
      setIsDropdownVisible(false)
    };
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsDropdownVisible(value.length > 0)
  };

  const handleSubmit = async (event:React.FormEvent<HTMLFormElement>)=>{
      event.preventDefault()
      if (userRegister.role === "Administrador Facultad" && (!userRegister.faculty || userRegister.faculty.length === 0)) {
        Swal.fire({
          title: "Facultad requerida",
          text: "Debe seleccionar al menos una facultad para el usuario Gestor Facultad.",
          icon: "error"
        });
        return;
      }
      try {
        const newPassword = userRegister.autoAssign ? generateRandomPassword(8) : userRegister.password;
        const authUser = {
          displayName: userRegister.name,
          email: userRegister.email,
          password: newPassword
        }
       const createAdmin = await userAdminService.signUpAdmin(authUser)
       if(createAdmin){
          let uidFaculty: string | string[] = [];
          let facultyName: string | string[] = [];

          if (userRegister.role !== "Administrador IES") {
            facultyName = Array.isArray(userRegister.faculty) ? userRegister.faculty : (userRegister.faculty ? [userRegister.faculty] : []);
            uidFaculty = (facultyName as string[]).map((fName) => {
              const matchedFaculty = faculties?.find((faculty) => faculty.name === fName);
              return matchedFaculty?.id || "";
            }).filter(Boolean);
          }
          const profileData = {
            uid: createAdmin, 
            displayName: userRegister.name,
            email: userRegister.email,
            emailVerified: false,
            phoneNumber: userRegister.phone,
            active: true,
            institute: userRegister.institution,
            ref: `/institutes/${userRegister.institution}` ,
            role: userRegister.role,
            faculty: facultyName,
            uidFaculty: uidFaculty,
            mustChangePassword: true,
          };
          const savedInFirestore = await userAdminService.saveUserProfile(profileData, createAdmin);
      
            if (savedInFirestore) {
              console.log("Registro exitoso en Firebase Authentication y Firestore");
              
              Swal.fire({
                title: "Usuario creado satisfactoriamente",
                icon: "success",
                html: `
                  <style>
                    .swal2-validation-message {
                      background-color: #f0fdf4 !important;
                      color: #166534 !important;
                      margin-top: 10px !important;
                    }
                    .swal2-validation-message::before {
                      background-color: #22c55e !important;
                    }
                  </style>
                  <div style="text-align: left; margin-top: 20px;">
                    <p><strong>Correo electrónico:</strong></p>
                    <div style="display: flex; align-items: center; gap: 10px; background: #f4f4f4; padding: 10px; border-radius: 5px; margin-bottom: 15px;">
                      <span style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${userRegister.email}</span>
                      <button id="copyEmail" class="swal2-confirm swal2-styled" style="margin: 0; padding: 5px 10px; font-size: 14px;">Copiar</button>
                    </div>
                    <p><strong>Contraseña:</strong></p>
                    <div style="display: flex; align-items: center; gap: 10px; background: #f4f4f4; padding: 10px; border-radius: 5px;">
                      <input type="password" id="swalPassword" value="${newPassword}" readonly style="flex-grow: 1; border: none; background: transparent; font-size: 16px; width: 50%"/>
                      <button id="toggleSwalPsw" class="swal2-confirm swal2-styled" style="margin: 0; padding: 5px 10px; font-size: 14px; background-color: #757575">Ver</button>
                      <button id="copyPsw" class="swal2-confirm swal2-styled" style="margin: 0; padding: 5px 10px; font-size: 14px;">Copiar</button>
                    </div>
                    <p style="margin-top: 15px; font-size: 14px; color: #d32f2f;"><strong>Nota:</strong> Esta es una clave temporal. El usuario deberá cambiarla al iniciar sesión.</p>
                  </div>
                `,
                showConfirmButton: true,
                confirmButtonText: "Cerrar",
                didOpen: () => {
                  const copyEmailBtn = document.getElementById('copyEmail');
                  const copyPswBtn = document.getElementById('copyPsw');
                  const togglePswBtn = document.getElementById('toggleSwalPsw');
                  const pswInput = document.getElementById('swalPassword') as HTMLInputElement;
 
                  copyEmailBtn?.addEventListener('click', () => {
                    navigator.clipboard.writeText(userRegister.email);
                    Swal.showValidationMessage('Correo copiado');
                    setTimeout(() => Swal.resetValidationMessage(), 1500);
                  });
 
                  copyPswBtn?.addEventListener('click', () => {
                    navigator.clipboard.writeText(newPassword);
                    Swal.showValidationMessage('Contraseña copiada');
                    setTimeout(() => Swal.resetValidationMessage(), 1500);
                  });
 
                  togglePswBtn?.addEventListener('click', () => {
                    if (pswInput.type === "password") {
                      pswInput.type = "text";
                      togglePswBtn.textContent = "Ocultar";
                    } else {
                      pswInput.type = "password";
                      togglePswBtn.textContent = "Ver";
                    }
                  });
                }
              });
 
              setUserRegister({
                email: "",
                institution: "",
                phone: "",
                name: "",
                faculty: [] as string[],
                role: "",
                password: "",
                confirmPassword: "",
                autoAssign: true
              });
              setSearchTerm("")
 
            } else {
              console.error("Error al guardar en Firestore");
              Swal.fire({
                title: "Error",
                text: "No se pudo guardar el perfil en la base de datos",
                icon: "error"
              });
            }
       } else {
         Swal.fire({
           title: "Error al crear usuario",
           text: "No se pudo crear el usuario en el sistema",
           icon: "error"
         });
       }
      
      } catch (error: any) {
        console.error(error);
        Swal.fire({
          title: "Error",
          text: error.message || "Error de conexión con el servidor",
          icon: "error"
        });
      }
  }
  
   const handlerChange = (event:any): void => {
    const {value, name} = event.target
    if (name === "institution") {
      const selectedInstitute = dataJSON.institutes.find((institute: any) => {
        const instituteCode = Object.keys(institute)[0];
        const instituteData = institute[instituteCode][1];
        return instituteData && instituteData.name === value;
      });
  
      if (selectedInstitute) {
        setUserRegister({
          ...userRegister,
          institution:Object.keys(selectedInstitute)[0]
         
        });
      }
    } else if (name === "role" && value !== "Administrador Facultad") {
      setUserRegister({
        ...userRegister,
        [name]: value,
        faculty: [] as string[]
      });
    } else {
      setUserRegister({
        ...userRegister,
        [name]: value
      });
    }
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setUserRegister((prevUser) => ({ ...prevUser, [name]: checked }));
  };
   
  useEffect(()=>{
    async function fetchFaculties() {
        if(selectedOption){
            try {
                const getFaculties = await facultyService.getAll(selectedOption)
                setFaculties(getFaculties)
            } catch (error) {
                console.error("Error trying to get faculties", error)
            }
        }            
    }
    fetchFaculties()
  },[selectedOption])

  return (
    <Box sx={{ padding:{xs:"5px",md:"5"}, width:"100%"}}>
      <Header title="Crear administrador" subtitle="Los campos marcados con * son obligatorios"/>
      
      <Box sx={{backgroundColor:colors.primary[400], width:"100%", display: "flex", justifyContent: "center"}}>
      <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "700px" }}>

      <Box 
      sx={{
        padding: 3,
        borderRadius: 2,
        border: `1px solid ${colors.blueAccent[500]}`,
        width:"100%",
        marginTop:"30px",
        backgroundColor: colors.primary[400]
      }}>
        <Grid container spacing={2.5} justifyContent="center" alignItems="center">
          
          <Grid item xs={12} sm={10} className="custom-select-container" sx={{ width: "100%" }}>
            <Box sx={{ position: "relative" }}>
                  <TextField
                    required
                    id="institution"
                    name="institution"
                    label="Buscar y seleccionar institución"
                    fullWidth
                    size="small"
                    autoComplete="off"
                    variant="outlined"
                    value={searchTerm}
                    onChange={handleInputChange} 
                    sx={{color:colors.grey[100]}}
                    InputLabelProps={{
                      style: { color: colors.grey[100],
                      fontSize:"16px" }
                    }}
                    InputProps={{
                      style:{ color: colors.grey[100],
                        fontSize:"16px" }
                    }}
                    />

                    <Box 
                      className={`custom-select ${isDropdownVisible ? 'visible' : ''}`}
                      sx={{color:colors.primary[600], fontWeight:"bold", fontSize:"16px"}}
                    >
                      {filteredOptions.length > 0 ? (
                        <ul>
                          {filteredOptions.map((option: InstituteOption) => (
                            <li key={option.value} onClick={() => handleSelectChange(option.value)}>
                              {option.label}
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </Box>
              </Box>
            </Grid>

              <Grid item xs={12} sm={10}>
                <FormControl fullWidth>
                <InputLabel id="role" sx={{color:colors.grey[100], fontSize:"16px"}}>Tipo de administrador</InputLabel>
                <Select
                  required
                  labelId="role"
                  id="role"
                  name="role"
                  value={userRegister.role}
                  onChange={handlerChange} 
                  
                >
                    <MenuItem value="Super Administrador" sx={{fontSize:"16px"}}>Super Administrador</MenuItem>
                    <MenuItem value="Administrador IES" sx={{fontSize:"16px"}}>Administrador IES</MenuItem>
                    <MenuItem value="Administrador Facultad" sx={{fontSize:"16px"}}>Gestor Facultad</MenuItem>
                    <MenuItem value="Profesor" sx={{fontSize:"16px"}}>Profesor</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

            {userRegister.role === "Administrador Facultad" && (
              <Grid item xs={12} sm={10}>
                <FormControl fullWidth>
                  <InputLabel id="faculty" sx={{color:colors.grey[100], fontSize:"16px"}}>Elija la facultad</InputLabel>
                  <Select
                    id="faculty"
                    name="faculty"
                    required
                    multiple
                    labelId="faculty"
                    value={Array.isArray(userRegister.faculty) ? userRegister.faculty : []}
                    onChange={handlerChange} 
                    renderValue={(selected) => (selected as string[]).join(', ')}
                    open={openFacultySelect}
                    onOpen={() => setOpenFacultySelect(true)}
                    onClose={() => setOpenFacultySelect(false)}
                    sx={{
                      color: colors.grey[100],
                      fontSize: 16,
                      width: "100%",
                      "& .MuiSelect-select": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block !important"
                      }
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: '4px 8px',
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenFacultySelect(false);
                        }}
                        sx={{ color: colors.grey[100] }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  {faculties?.map((faculty)=>(
                    <MenuItem  key={faculty.id} value={faculty.name} sx={{fontSize:"16px"}}>
                      <Checkbox checked={Array.isArray(userRegister.faculty) && userRegister.faculty.indexOf(faculty.name) > -1} />
                      {faculty.name}
                    </MenuItem>
                  ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

          <Grid item xs={12} sm={10}>
              <TextField
                required
                id="name"
                name="name"
                label="Nombres y Apellidos"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                value={userRegister.name}
                onChange={handlerChange} 
                sx={{color:colors.grey[100]}}
                InputLabelProps={{
                  style: { color: colors.grey[100],
                  fontSize:"16px" }
                }}
                InputProps={{
                  style:{ color: colors.grey[100],
                    fontSize:"16px" }
                }}
                  />
            </Grid>

            <Grid item xs={12} sm={10}>
              <TextField
                type="tel"
                id="phone"
                name="phone"
                value={userRegister.phone}
                label="Número de contacto"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                onChange={handlerChange} 
                sx={{color:colors.grey[100]}}
                InputLabelProps={{
                  style: { color: colors.grey[100],
                  fontSize:"16px",
                }
                }}
                InputProps={{
                  style:{ color: colors.grey[100],
                    fontSize:"16px" }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={10}>           
              <TextField
                required
                type="email"
                name="email"
                id="email"
                label="Correo electrónico"
                fullWidth
                size="small"
                autoComplete="off"
                variant="outlined"
                value={userRegister.email}             
                onChange={handlerChange}
                sx={{color:colors.grey[100]}}
                InputLabelProps={{
                  style: { color: colors.grey[100],
                  fontSize:"16px" }
                }}
                InputProps={{
                  style:{ color: colors.grey[100],
                    fontSize:"16px" }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={10} sx={{ width: "100%", display: "flex", justifyContent: "flex-start", gridColumn: "1 / -1" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={userRegister.autoAssign}
                    onChange={handleCheckboxChange}
                    name="autoAssign"
                    sx={{ color: colors.grey[100], '&.Mui-checked': { color: colors.blueAccent[500] } }}
                  />
                }
                label={<Typography sx={{ color: colors.grey[100] }}>Asignar contraseña automáticamente</Typography>}
              />
            </Grid>

            {!userRegister.autoAssign && (
              <>
                <Grid item xs={12} sm={10}>
                  <TextField
                    required
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    label="Contraseña"
                    fullWidth
                    size="small"
                    autoComplete="off"
                    variant="outlined"
                    value={userRegister.password}
                    onChange={handlerChange}
                    sx={{ color: colors.grey[100] }}
                    InputLabelProps={{
                      style: {
                        color: colors.grey[100],
                        fontSize: "16px"
                      },
                    }}
                    InputProps={{
                      style: { color: colors.grey[100], fontSize: "16px", height: "45px" },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            sx={{ color: colors.grey[100] }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={10}>
                  <TextField
                    required
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    label="Repetir contraseña"
                    fullWidth
                    size="small"
                    autoComplete="off"
                    variant="outlined"
                    value={userRegister.confirmPassword}
                    onChange={handlerChange}
                    error={userRegister.password !== userRegister.confirmPassword && userRegister.confirmPassword !== ""}
                    helperText={userRegister.password !== userRegister.confirmPassword && userRegister.confirmPassword !== "" ? 'Las contraseñas no coinciden' : ''}
                    sx={{ color: colors.grey[100] }}
                    InputLabelProps={{
                      style: {
                        color: colors.grey[100],
                        fontSize: "16px"
                      },
                    }}
                    InputProps={{
                      style: { color: colors.grey[100], fontSize: "16px", height: "45px" },
                    }}
                  />
                </Grid>
              </>
            )}
             <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
              <Button 
                sx={{
                  backgroundColor:colors.grey[100],
                  color:"#f2f0f0",            
                  borderRadius:"5px",
                  fontWeight:"bolder",
                  fontSize:"16px",
                  ":hover":{
                    cursor:"pointer",
                    backgroundColor: colors.grey[100]
                  },
                  width: "fit-content"
                }}
                disabled={
                  (!userRegister.autoAssign && (userRegister.password === "" || userRegister.password !== userRegister.confirmPassword)) ||
                  (userRegister.role === "Administrador Facultad" && (!userRegister.faculty || userRegister.faculty.length === 0))
                }
                type="submit"
              >
                Crear Administrador
              </Button>
            </Grid>
          </Grid>
          </Box>
          </form>
          </Box>
    </Box>
  );
}
